import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Benefits from "../components/landing/Benefits";
import EditorialMarquee from "../components/landing/Marquee";
import About from "../components/landing/About";
import Services from "../components/landing/Services";
import Stats from "../components/landing/Stats";
import Gallery from "../components/landing/Gallery";
import Testimonials from "../components/landing/Testimonials";
import Timeline from "../components/landing/Timeline";
import Faq from "../components/landing/Faq";
import ServiceMap from "../components/landing/ServiceMap";
import Cta from "../components/landing/Cta";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import WhatsAppFab from "../components/landing/WhatsApp";

export default function Home() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="relative bg-white text-ink">
            <div className="bg-noise pointer-events-none fixed inset-0 z-[5] opacity-[0.03]" aria-hidden />
            <Navbar />
            <main>
                <Hero />
                <Benefits />
                <EditorialMarquee />
                <About />
                <Services />
                <Stats />
                <Gallery />
                <Testimonials />
                <Timeline />
                <Faq />
                <ServiceMap />
                <Cta />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFab />
        </div>
    );
}
